import { useRef } from "react";
import {
  Box,
  Grid,
  CardHeader,
  Paper,
  TextField,
  IconButton,
  Tooltip,
  Button,
  Select,
  MenuItem,
} from "../../../../../components";
import EmojiPicker from "emoji-picker-react";
import { Popover } from "@mui/material";
import {
  contextos,
  contextosLote,
  variaveisDisponiveis,
} from "../../../resources/constantes";
import CelularMensagemMock from "../celular-mock.component";
import Mousetrap from "mousetrap";
import { AnexoMensagemLote } from "./anexo-mensagem-lote.component";

export function MensagemPersonalizadaForm({
  id,
  mensagem,
  handleChange,
  handleOpenEmojiPicker,
  handleEmojiSelect,
  inserirVariavel,
  emojiAnchorEl,
  inputErros,
  msgLote,
  imageAnexo,
  setImageAnexo,
}) {
  const emojiButtonRef = useRef(null);

  const atalhosAddLayout = [
    {
      keys: ["ctrl+e", "command+e"],
      action: async (e) => {
        e.preventDefault();
        const emoji = document.getElementById("emojiButton");
        emoji.click();
        return false;
      },
    },
  ];

  atalhosAddLayout.map(({ keys, action }) => Mousetrap.bind(keys, action));

  Mousetrap.stopCallback = function () {
    return false;
  };

  const contextosShow =
    mensagem?.tipo === "LOTE" || msgLote ? contextosLote : contextos;

  return (
    <Grid
      container
      spacing={2}
      sx={{ px: 2, height: "calc(100% - 7rem) !important" }}
    >
      <Grid item xs={12} md={9}>
        <Paper
          className="d-flex"
          sx={{
            px: 3,
            py: 2,
            height: "100%",
            boxShadow: "0px 0px 56px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Grid item xs={12} md={5}>
            {msgLote || mensagem?.tipo === "LOTE" ? (
              <AnexoMensagemLote
                imageAnexo={imageAnexo}
                setImageAnexo={setImageAnexo}
              />
            ) : (
              <>
                <CardHeader title="configuração" />
                <Select
                  fullWidth
                  name="contexto"
                  value={mensagem?.contexto}
                  onChange={handleChange}
                  label="Contexto da Mensagem"
                  disabled={id}
                  margin="normal"
                  error={inputErros.get("contexto")}
                >
                  {contextosShow.map((status, index) => (
                    <MenuItem key={index} value={status.value}>
                      {status.label}
                    </MenuItem>
                  ))}
                </Select>
              </>
            )}

            <Box sx={{ mt: 2 }}>
              <CardHeader title="variáveis disponíveis" />
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {variaveisDisponiveis.map((variavel, index) => {
                  if (
                    !mensagem?.contexto?.includes("Servico") &&
                    variavel.includes("Agendamento")
                  )
                    return;
                  return (
                    <Button
                      id={`var-${index + 1}`}
                      key={variavel}
                      variant="outlined"
                      size="small"
                      onClick={() => inserirVariavel(variavel)}
                      sx={{
                        borderRadius: "16px",
                        textTransform: "none",
                        fontSize: "0.75rem",
                        padding: "4px 12px",
                        borderColor: "#ddd",
                        color: "#555",
                        "&:hover": {
                          backgroundColor: "#f5f5f5",
                          borderColor: "#ccc",
                        },
                      }}
                    >
                      {`{${variavel}}`}
                    </Button>
                  );
                })}
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={1} className="d-flex justify-content-center">
            <hr className="vr" />
          </Grid>

          <Grid item xs={12} md={6.5}>
            <CardHeader title="editor de mensagem" />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "calc(100% - 100px)",
              }}
            >
              <TextField
                id="mensagem"
                name="mensagem"
                label="Texto da Mensagem"
                margin="normal"
                fullWidth
                multiline
                rows={8}
                required
                helperText="Use *texto* para negrito e _texto_ para itálico"
                sx={{ flexGrow: 1 }}
                onChange={handleChange}
                value={mensagem?.mensagem}
                error={inputErros.get("mensagem")}
              />

              <Box sx={{ display: "flex", justifyContent: "flex-end", m: 1 }}>
                <Tooltip title="CTRL + E" arrow placement="top">
                  <IconButton
                    id="emojiButton"
                    ref={emojiButtonRef}
                    onClick={handleOpenEmojiPicker}
                    aria-label="adicionar emoji"
                    size="small"
                  >
                    <i
                      className="ph-bold ph-smiley"
                      style={{ fontSize: "20px" }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            <Popover
              open={Boolean(emojiAnchorEl)}
              anchorEl={emojiAnchorEl}
              onClose={() => handleOpenEmojiPicker(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <EmojiPicker
                onEmojiClick={handleEmojiSelect}
                width={300}
                height={350}
                previewConfig={{ showPreview: false }}
                skinTonesDisabled
                searchDisabled
              />
            </Popover>
          </Grid>
        </Paper>
      </Grid>

      <Grid
        item
        xs={12}
        md={3}
        className="d-flex justify-content-center align-items-center"
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CelularMensagemMock
            mensagem={mensagem?.mensagem}
            imageAnexo={imageAnexo}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
